import React from 'react';
import { useNavigate } from 'react-router-dom';
import RequestPNG from '../../assets/icons/png/Request.png';
import ArrowNextIconSVG from '../../assets/icons/svg/ArrowNextIconSVG';
import Breadcrumb from '../../../SharedComponents/components/Breadcrumb/Breadcrumb';


const WithoutRequests = ({ user }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/store');
  };

  let breadcrumbs;
  let title;


  breadcrumbs = [
    { title: 'Početak', href: '/home-page' },
    { title: 'Zahtevi za ponude', href: '#' }
  ];
  title = 'Zahtevi za ponude';


  return (
    <div>
      <div style={styles.breadcrumb}>
        <Breadcrumb title={title} breadcrumbs={breadcrumbs} />
      </div>
      <div style={styles.wrapper} >
        <div style={styles.iconBox}>
          <img src={RequestPNG} alt="premium" style={styles.icon} />
        </div>
        <div style={styles.textBox}>
          <div style={styles.title}>
            Nema aktivnih zahteva za tvoj asortiman delova.
          </div>
          <div style={styles.description}>
            Dodaj nove delove u asortiman i povećaj šansu za više kupaca.
          </div>
        </div>
      </div>

      <div style={styles.buttonWrapper}>
        <div style={styles.buttonWithText}>
          <button style={styles.ctaButton} onClick={handleClick}>
            Dodaj modele automobila
            <ArrowNextIconSVG />
          </button>
          <p style={styles.underButtonText}>
            Odaberi za koje modele nudiš delove
          </p>
        </div>
      </div>
    </div>
  );
};

export default WithoutRequests;


const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '6px',
    cursor: 'pointer',
    width: '460px',
    gap: '20px',
    border: '2px solid rgba(91, 33, 182, 1)',
    backgroundColor: 'rgba(245, 245, 244, 1)',
    minHeight: '300px',
  },
  iconBox: {
    width: '195px',
    height: '160px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px',
  },
  textBox: {
    width: '100%',
    padding: '0',
  },
  title: {
    color: 'rgba(91, 33, 182, 1)',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '0.2px',
    textAlign: 'left',
    lineHeight: '20px',
    marginBottom: '8px',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'left',
    lineHeight: '24px',
  },
  ctaButton: {
    backgroundColor: '#000',
    padding: '12px 24px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    marginTop: '20px',
    opacity: 0.99,
    color: "#FFFFFF",
    fontSize: '20px',
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: '20px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px',
  },

  buttonWithText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },


  underButtonText: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    fontWeight: '400',
    fontStyle: 'Regular',
    letterSpacing: '0px',
    textAlign: 'center',
    lineHeight: '24px',
    marginTop: '10px',
    marginRight: '20px'
  },
  breadcrumb: {
    marginBottom: '30px',
    marginTop: '20px'
  }

};
